import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
declare var d3: any;

@Component({
  selector: 'app-bars',
  templateUrl: './bars.component.html',
  styleUrls: ['./bars.component.css']
})
export class BarsComponent implements OnInit {
  @Input() labels: any;
  @ViewChild('chart') private chartContainer: ElementRef;
  @ViewChild('chart2') private chartContainer2: ElementRef;
  fuelcounts;
  data;
  constructor(private renderer: Renderer2) {
  }

  ngOnInit() {
  }
  updateData(fuelcount: any){
    let p = fuelcount;
    let data = [];
    for (var key in p) {
      if (p.hasOwnProperty(key)) {
        let item = [
          this.labels[key] , parseInt(p[key])
        ]
        data.push(item);
      }
    }
    return data;
  }
  
  onUpdate(fuelcounts: any){
    this.fuelcounts = fuelcounts;
    let data = this.updateData(fuelcounts["7-days"]);
    setTimeout(()=>{
      this.createChart(this.chartContainer, data, "");
    });
  }
  createChart(container, data, unit) {
    if(container.nativeElement.children.length > 0){
      let _t = container.nativeElement.children[0];
      _t.remove();
    }
    const element = container.nativeElement;

    var margin = {top: 40, right: 20, bottom: 80, left: 20},
    width = element.offsetWidth - margin.left - margin.right,
    height = element.offsetHeight - margin.top - margin.bottom;

    var svg = d3.select(element).append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform",
              "translate(" + margin.left + "," + margin.top + ")");

    var xDomain = data.map(d => d[0]);
    var yDomain = [0, d3.max(data, d => d[1])];

    var xScale = d3.scaleBand().padding(0.1).domain(xDomain).rangeRound([0, width]);
    var yScale = d3.scaleLinear().domain(yDomain).range([height, 0]);
    var xAxis = svg.append('g')
          .attr('class', 'axis axis-x')
          .style("font-size", "14px")
          .attr('transform', `translate(${margin.left}, ${margin.top + height})`)
          .call(d3.axisBottom(xScale));

    var yAxis = svg.append('g')
          .attr('class', 'axis axis-y')
          .style("font-size", "14px")
          .attr('transform', `translate(${margin.left}, ${margin.top})`)
          .call(d3.axisLeft(yScale));
    
    var yLabel = svg.append("text")      // text label for the x axis
          .attr("x", 0 )
          .attr("y", 10 )
          .style("text-anchor", "middle")
          .style("font-size", "14px")
          .text(unit);

    svg.selectAll('.bar')
      .data(data)
      .enter().append("rect")
          .attr("class", "bar")
          .attr("fill", "#BE0000")
          .attr("x", function(d) { return xScale(d[0])+margin.left; })
          .attr("y", function(d) { return yScale(d[1])+margin.top; })
          .attr("width", xScale.bandwidth())
          .attr("height", function(d) { return height - yScale(d[1]); });
      }
}



// WEBPACK FOOTER //
// ./src/app/chart/bars/bars.component.ts